import React from "react";

const StatusBadge = ({ status }) => {
    // Convert past statuses to current display text
    const displayStatus =
        status === "Past Data Pending for Checker Review"
            ? "Pending for Checker Review"
            : status === "Past Data Pending for Maker Modification"
                ? "Pending for Maker Modification"
                : status === "Past Data Approved"
                    ? "Data Approved"
                    : status;

    const statusConfig = {
        "Pending for Maker Modification": {
            icon: "bi-pencil-square",
            bg: "bg-warning-subtle",
            text: "text-warning",
            border: "border-warning",
        },
        "Pending for Checker Modification": {
            icon: "bi-arrow-repeat",
            bg: "bg-danger-subtle",
            text: "text-danger",
            border: "border-danger",
        },
        "Pending for Checker Review": {
            icon: "bi-hourglass-split",
            bg: "bg-info-subtle",
            text: "text-info",
            border: "border-info",
        },
        "Data Overridden": {
            icon: "bi-database-fill-exclamation",
            bg: "bg-secondary-subtle",
            text: "text-secondary",
            border: "border-secondary",
        },
        "Data Approved": {
            icon: "bi-check-circle-fill",
            bg: "bg-success-subtle",
            text: "text-success",
            border: "border-success",
        },
        "Data Reinstated": {
            icon: "bi-arrow-clockwise",
            bg: "bg-primary-subtle",
            text: "text-primary",
            border: "border-primary",
        },
		"Data Uploaded to SAMA": {
            icon: "bi-check-circle-fill",
            bg: "bg-success-subtle",
            text: "text-success",
            border: "border-primary",
        },
    };

    const config = statusConfig[displayStatus] || {
        icon: "bi-question-circle",
        bg: "bg-light",
        text: "text-dark",
    };

    return (
        <span
            className={`badge rounded-pill px-3 py-2 d-inline-flex align-items-center border ${config.bg} ${config.text}`}
            style={{
                fontSize: "0.82rem",
                fontWeight: 500,
            }}
        >
            <i className={`bi ${config.icon} me-2`}></i>
            {displayStatus}
        </span>
    );
};

export default StatusBadge;